import React, {useState} from "react";

import clothesData from "./traits/clothes.json";
import shoesData from "./traits/shoes.json";
import handToolsData from "./traits/hand-tools.json";
import glovesData from "./traits/gloves.json";
import hairData from "./traits/hair.json";
import hatData from "./traits/hat.json";
import faceHairData from "./traits/face-hair.json";
import glassesData from "./traits/glasses.json";

import FarmerImage from "./FarmerImage";

function Designer() {
    const [clothes, setClothes] = useState<string>("-1");
    const [shoes, setShoes] = useState<string>("-1");
    const [handTools, setHandTools] = useState<string>("-1");
    const [gloves, setGloves] = useState<string>("-1");
    const [hair, setHair] = useState<string>("-1");
    const [hat, setHat] = useState<string>("-1");
    const [faceHair, setFaceHair] = useState<string>("-1");
    const [glasses, setGlasses] = useState<string>("-1");

    /*


    console.log("_clothes", _clothes);
    console.log("_shoes", _shoes);
    console.log("_handTools", _handTools);
    console.log("_gloves", _gloves);
    console.log("_hair", _hair);
    console.log("_hat", _hat);
    console.log("_faceHair", _faceHair);
    console.log("_glasses", _glasses);
    console.log("---------------------------");
    */

    return <div className="designer">
        <div className="editor">
            <div className="mb-3">
                <label className="form-label">Clothes</label>
                <select className="form-control" value={clothes} onChange={(e) => {
                    setClothes(e.target.value)
                }}>
                    <option value="-1">--</option>
                    {clothesData.map(x => <option key={x.id} value={x.id}>{x.name}</option>)}
                </select>
            </div>
            <div className="mb-3">
                <label className="form-label">Shoes</label>
                <select className="form-control" value={shoes} onChange={(e) => {
                    setShoes(e.target.value)
                }}>
                    <option value="-1">--</option>
                    {shoesData.map(x => <option key={x.id} value={x.id}>{x.name}</option>)}
                </select>
            </div>
            <div className="mb-3">
                <label className="form-label">Hand Tools</label>
                <select className="form-control" value={handTools} onChange={(e) => {
                    setHandTools(e.target.value)
                }}>
                    <option value="-1">--</option>
                    {handToolsData.map(x => <option key={x.id} value={x.id}>{x.name}</option>)}
                </select>
            </div>
            <div className="mb-3">
                <label className="form-label">Gloves</label>
                <select className="form-control" value={gloves} onChange={(e) => {
                    setGloves(e.target.value)
                }}>
                    <option value="-1">--</option>
                    {glovesData.map(x => <option key={x.id} value={x.id}>{x.name}</option>)}
                </select>
            </div>
            <div className="mb-3">
                <label className="form-label">Hair</label>
                <select className="form-control" value={hair} onChange={(e) => {
                    setHair(e.target.value)
                }}>
                    <option value="-1">--</option>
                    {hairData.map(x => <option key={x.id} value={x.id}>{x.name}</option>)}
                </select>
            </div>
            <div className="mb-3">
                <label className="form-label">Hat</label>
                <select className="form-control" value={hat} onChange={(e) => {
                    setHat(e.target.value)
                }}>
                    <option value="-1">--</option>
                    {hatData.map(x => <option key={x.id} value={x.id}>{x.name}</option>)}
                </select>
            </div>
            <div className="mb-3">
                <label className="form-label">Face Hair</label>
                <select className="form-control" value={faceHair} onChange={(e) => {
                    setFaceHair(e.target.value)
                }}>
                    <option value="-1">--</option>
                    {faceHairData.map(x => <option key={x.id} value={x.id}>{x.name}</option>)}
                </select>
            </div>
            <div className="mb-3">
                <label className="form-label">Glasses</label>
                <select className="form-control" value={glasses} onChange={(e) => {
                    setGlasses(e.target.value)
                }}>
                    <option value="-1">--</option>
                    {glassesData.map(x => <option key={x.id} value={x.id}>{x.name}</option>)}
                </select>
            </div>
        </div>

        <FarmerImage width="600px" height="600px" clothes={Number(clothes)} shoes={Number(shoes)} handTools={Number(handTools)}
                     gloves={Number(gloves)} hair={Number(hair)} hat={Number(hat)} faceHair={Number(faceHair)}
                     glasses={Number(glasses)}/>
    </div>
}

export default Designer